<div class="px-lg-5 py-3 py-lg-4 py-xxl-5">
    <span class="fs-20 text-secondary">Add your</span>
    <h1 class="fs-40 text-headingGrey mb-3">Company details</h1>
    <div class="fs-20 text-secondary mb-3 mb-lg-4">
        To generate recommendations, we need access to your energy details. Please provide your company information to
        continue.
    </div>

    <form [formGroup]="companyForm" (keyup.enter)="onSubmit()">
        <div class="mb-3 search-container position-relative">
            <label class="fs-14 text-bodyGrey fw400 mb-1"> Select company </label>
            <ng-select class="form-ngselect" (change)="onBrokerCompanyChange($event)" [loading]="isBrokerCompanyLoading"
                [items]="companyList" bindLabel="companyName" bindValue="companyName" placeholder="Select company"
                formControlName="brokerCompanyName">
            </ng-select>
            <p *ngIf="f1?.['brokerCompanyName']?.touched && f1?.['brokerCompanyName']?.required"
                class="text-danger fs-14 mb-0">
                Company is required
            </p>
        </div>
        <ng-container
            *ngIf="f1?.['brokerCompanyName']?.value && f1?.['brokerCompanyName']?.value != '+ Add new company'">
            <div class="row mb-3" *ngIf="f1?.['companyType'].value">
                <div class="col-lg-6">
                    <label class="fs-14 text-bodyGrey fw400 mb-1"> Company type </label>
                    <p class="mb-0 fs-16 text-black">{{ f1?.['companyType'].value }}</p>
                </div>
                <div class="col-lg-6">
                    <label class="fs-14 text-bodyGrey fw400 mb-1"> Company number </label>
                    <p class="mb-0 fs-16 text-black">{{ f1?.['companyNumber'].value }}</p>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-lg-12">
                    <label class="fs-14 text-bodyGrey fw400 mb-1"> Company address </label>
                    <p class="mb-0 fs-16 text-black">{{ f1?.['companyAddress'].value }}</p>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="f1?.['brokerCompanyName']?.value == '+ Add new company'">
            <div class="mb-3 search-container position-relative">
                <label class="fs-14 text-bodyGrey fw400 mb-1" for="">Company name</label>
                <ng-select class="form-ngselect" [virtualScroll]="true" [loading]="isCompanyLoading" formControlName="companyName"
                    placeholder="Start by typing your company name"
                    typeToSearchText="Please enter {{minLengthTerm}} or more char" [minTermLength]="minLengthTerm"
                    [typeahead]="companyInput$" [trackByFn]="trackByFn" (change)="selectCompany($event)"
                    (clear)="clearList()">
                    <ng-option *ngFor="let item of companies$ | async" [value]="item">{{item.name }}</ng-option>
                </ng-select>
                <p *ngIf="getFormControl('companyName')?.touched && getErrorControl('companyName')?.['required']"
                    class="text-danger fs-14 mb-0">
                    Company Name is required
                </p>
            </div>
    
            <div class="mb-3" *ngIf="!!isCompanyAddressLoading">
                <p class="placeholder-wave">
                    <span class="placeholder placeholder-xs bg-bodyGrey w-25"></span>
                    <span class="placeholder placeholder-sm bg-bodyGrey w-100"></span>
                </p>
            </div>
    
            <div class="mb-3" *ngIf="!isCompanyAddressLoading && !!isCompanyAddress">
                <label class="fs-14 text-bodyGrey fw400 mb-1" for="">Company address</label>
                <p class="mb-0">{{ companyAddress }}</p>
            </div>
        </ng-container>


        <ng-container *ngIf="isManualCompany">
            <div class="mb-3" *ngIf="!isCompanyNoAddress">
                <label class="fs-14 text-bodyGrey fw400 mb-1" for="">Company name(Enter manually)</label>
                <input type="text" class="form-control inputTyp1" id="cNameManual" placeholder="Enter company name"
                    formControlName="companyNameManual" />
                <p *ngIf="getFormControl('companyNameManual')?.touched && getErrorControl('companyNameManual')?.['required']"
                    class="text-danger fs-14 mb-0">
                    Company Name is required
                </p>
            </div>

            <div class="mb-3 search-container position-relative">
                <label class="fs-14 text-bodyGrey fw400 mb-1" for="">Company Type</label>
                <ng-select class="form-ngselect" [clearable]="false" formControlName="companyType" placeholder="Select company type"
                    [items]="companyTypes" bindLabel="display_name" bindValue="name">
                </ng-select>
                <p *ngIf="getFormControl('companyType')?.touched && getErrorControl('companyType')?.['required']"
                    class="text-danger fs-14 mb-0">
                    Company type is required
                </p>
            </div>

            <div class="mb-3">
                <label class="fs-14 text-bodyGrey fw400 mb-1" for="">Company number</label>
                <input type="text" class="form-control inputTyp1" placeholder="Enter company number"
                    formControlName="companyNumber" />
                <p *ngIf="getFormControl('companyNumber')?.touched && getErrorControl('companyNumber')?.['required']"
                    class="text-danger fs-14 mb-0">
                    Company number is required
                </p>
            </div>

            <div class="mb-3 search-container position-relative">
                <label class="fs-14 text-bodyGrey fw400 mb-1" for="addressDropdown">Search company address</label>
                <ng-select class="form-ngselect" id="addressDropdown" (change)="selectedGBGAddress($event)" [virtualScroll]="true"
                    [clearable]="true" (search)="searchFreeText($event)" formControlName="companyAddress"
                    placeholder="Start by typing your address or postcode." [loading]="isAddressLoading"
                    [minTermLength]="3">
                    <ng-option *ngFor="let address of listOfAddress" [value]="address">{{ address.fullAddress
                        }}</ng-option>
                </ng-select>
                <p class="my-2 text-danger fs-14" *ngIf="!!invalidAddress">
                    {{ invalidAddress }}
                </p>
                <p *ngIf="getFormControl('companyAddress')?.touched && getFormControl('companyAddress')?.errors?.['required']"
                    class="text-danger fs-14 mb-0">
                    Company address is required
                </p>
            </div>

            <div formGroupName="address" *ngIf="companyForm?.get('address') && !!isCompanyAddressNotInList">
                <div class="mb-3">
                    <label class="fs-14 text-bodyGrey fw400 mb-1" for="">Locality</label>
                    <input type="text" class="form-control inputTyp1" formControlName="locality" autocomplete="off" />
                    <p *ngIf="getFormControl('address')?.get('locality')?.touched && getFormControl('address')?.get('locality')?.errors?.['required']"
                        class="text-danger fs-14 mb-0">
                        Locality is required
                    </p>
                </div>
                <div class="mb-3">
                    <label class="fs-14 text-bodyGrey fw400 mb-1" for="">Address 1</label>
                    <input type="text" class="form-control inputTyp1" formControlName="address_line_1"
                        autocomplete="off" />
                    <p *ngIf="getFormControl('address.address_line_1')?.touched && getFormControl('address.address_line_1')?.errors?.['required']"
                        class="text-danger fs-14 mb-0">
                        Address is required
                    </p>
                </div>
                <div class="mb-3">
                    <label class="fs-14 text-bodyGrey fw400 mb-1" for="">Address 2</label>
                    <input type="text" class="form-control inputTyp1" formControlName="address_line_2"
                        autocomplete="off" />
                </div>
                <div class="mb-3">
                    <label class="fs-14 text-bodyGrey fw400 mb-1" for="">Country</label>
                    <input type="text" class="form-control inputTyp1" formControlName="country" autocomplete="off" />
                    <p *ngIf="getFormControl('address.country')?.touched && getFormControl('address.country')?.errors?.['required']"
                        class="text-danger fs-14 mb-0">
                        Country is required
                    </p>
                </div>
                <div class="mb-3">
                    <label class="fs-14 text-bodyGrey fw400 mb-1" for="">Postcode</label>
                    <input type="text" class="form-control inputTyp1" formControlName="postal_code"
                        autocomplete="off" />
                    <span class="text-danger fs-14 mt-1"
                        *ngIf="companyForm.get('address.postal_code')?.errors?.['pattern']">Please
                        enter a valid postcode.</span>
                    <p *ngIf="getFormControl('address.postal_code')?.touched && getFormControl('address.postal_code')?.errors?.['required']"
                        class="text-danger fs-14 mb-0">
                        Postcode is required
                    </p>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="f1?.['companyName'].value">
            <div class="mb-3">
                <div class="form-group">
                    <label class="fs-14 text-bodyGrey fw400 mb-1"> Select an authorized person for your site </label>
                    <ng-select class="form-ngselect" [loading]="isContactLoading" placeholder="Select authorise person"
                        (change)="selectedContact($event)" [searchable]="false" [clearable]="false">
                        <ng-option *ngFor="let contact of listOfContacts; let i = index" [value]="contact">
                            {{ contact.firstName + ' ' + contact.lastName }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="mb-3">
                <div class="form-group">
                    <label for="" class="fs-14 text-bodyGrey fw400 mb-1">Title</label>
                    <ng-select class="form-ngselect" placeholder="Select title" formControlName="title"
                        [searchable]="false" [clearable]="true">
                        <ng-option *ngFor="let item of listOfTitles" [value]="item">{{ item }}</ng-option>
                    </ng-select>
                    <p *ngIf="companyForm.get('title')?.touched && companyForm.get('title')?.errors"
                        class="text-danger fs-14 mt-1 mb-0">
                        <span *ngIf="companyForm.get('title')?.hasError('required')">Title is required</span>
                    </p>
                </div>
            </div>
            <div class="mb-3">
                <div class="form-group">
                    <label for="" class="fs-14 text-bodyGrey fw400 mb-1">First name</label>
                    <input type="text" class="form-control inputTyp1" formControlName="firstName"
                        placeholder="Enter first name">
                    <p *ngIf="companyForm.get('firstName')?.touched && companyForm.get('firstName')?.errors"
                        class="text-danger fs-14 mt-1 mb-0">
                        <span *ngIf="companyForm.get('firstName')?.hasError('required')">First name is
                            required</span>
                        <span *ngIf="companyForm.get('firstName')?.hasError('minlength')">First
                            name should be at least 2 characters. please enter a valid first name.</span>
                        <span *ngIf="companyForm.get('firstName')?.hasError('pattern')">please enter a valid
                            first
                            name.</span>
                    </p>
                </div>
            </div>
            <div class="mb-3">
                <div class="form-group">
                    <label for="" class="fs-14 text-bodyGrey fw400 mb-1">Last name</label>
                    <input type="text" class="form-control inputTyp1" formControlName="lastName"
                        placeholder="Enter last name">
                    <p *ngIf="companyForm.get('lastName')?.touched && companyForm.get('lastName')?.errors"
                        class="text-danger fs-14 mt-1 mb-0">
                        <span *ngIf="companyForm.get('lastName')?.hasError('required')">Last name is
                            required</span>
                        <span *ngIf="companyForm.get('lastName')?.hasError('minlength')">Last
                            name should be at least 2 characters. please enter a valid last name.</span>
                        <span *ngIf="companyForm.get('lastName')?.hasError('pattern')">please enter a valid last
                            name.</span>
                    </p>
                </div>
            </div>
            <div class="mb-3">
                <div class="form-group">
                    <label for="" class="fs-14 text-bodyGrey fw400 mb-1">Mobile</label>
                    <input type="text" class="form-control inputTyp1" formControlName="phone" inputmode="numeric"
                        placeholder="Enter phone">
                    <p *ngIf="companyForm.get('phone')?.touched && companyForm.get('phone')?.errors"
                        class="text-danger fs-14 mt-1 mb-0">
                        <span *ngIf="companyForm.get('phone')?.hasError('required')">Mobile is required</span>
                        <span
                            *ngIf="companyForm.get('phone')?.hasError('minlength') || companyForm.get('phone')?.hasError('pattern')">Please
                            provide a valid mobile number.</span>
                    </p>
                </div>
            </div>
            <div class="mb-3">
                <div class="form-group">
                    <label for="" class="fs-14 text-bodyGrey fw400 mb-1">Email</label>
                    <input type="email" class="form-control inputTyp1" formControlName="contactEmail"
                        placeholder="Enter email">
                    <p *ngIf="companyForm.get('contactEmail')?.touched && companyForm.get('contactEmail')?.errors"
                        class="text-danger fs-14 mt-1 mb-0">
                        <span *ngIf="companyForm.get('contactEmail')?.hasError('required')">Email is
                            required</span>
                        <span *ngIf="companyForm?.get('contactEmail')?.hasError('pattern')">Please provide a
                            valid email
                            address.</span>
                    </p>
                </div>
            </div>
        </ng-container>

    </form>
    <div class="mb-2 text-center text-danger" *ngIf="!!errorMessage">
        {{ errorMessage }}
    </div>
    <p *ngIf="successMessage" class="mb-2 text-success mb-0 fw-semibold">{{ successMessage }}</p>
    <div class="text-center">
        <button type="button" class="GA-register btn-primary w-100" [disabled]="companyForm.invalid"
            (click)="onSubmit()">
            Save
        </button>
        <button type="button" class="mt-2 GA-registerClose btn-secondary w-100" (click)="close()">
            Close
        </button>
    </div>
</div>